import React from 'react';
import helmetLogo from '../assets/helmet.png';
import ProfileImage from './ProfileImage';

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 24px',
    background: 'var(--color-surface)',
    borderBottom: '1px solid var(--color-border)',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  logo: {
    height: 36,
  },
  title: {
    fontFamily: 'var(--font-heading)',
    fontSize: 20,
    fontWeight: 700,
    color: 'var(--color-secondary)',
    letterSpacing: 2,
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  user: {
    fontFamily: 'var(--font-body)',
    fontSize: 14,
    color: 'var(--color-text-dim)',
  },
  navGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginLeft: 16,
  },
  button: {
    padding: '6px 16px',
    background: 'transparent',
    border: '1px solid var(--color-border)',
    borderRadius: 4,
    color: 'var(--color-text-dim)',
    fontFamily: 'var(--font-body)',
    fontSize: 13,
    cursor: 'pointer',
  },
};

export default function Header({ user, onLogout, onBack, showBack, onAdmin, onDashboard, onProfile, onBlog }) {
  const hasNav = showBack || onDashboard || onAdmin || onBlog;
  return (
    <header style={styles.header} data-doc-id="app-header">
      <div style={styles.left}>
        <img src={helmetLogo} alt="RaceVoice" style={styles.logo} />
        <span style={styles.title}>RACEVOICE</span>
        {hasNav && (
          <div style={styles.navGroup}>
            {showBack && (
              <button style={styles.button} onClick={onBack} data-doc-id="header-back">
                Back
              </button>
            )}
            {onDashboard && (
              <button style={styles.button} onClick={onDashboard} data-doc-id="header-dashboard">
                Dashboard
              </button>
            )}
            {onBlog && (
              <button style={styles.button} onClick={onBlog} data-doc-id="header-blog">
                Blog
              </button>
            )}
            {onAdmin && (
              <button style={{ ...styles.button, borderColor: 'var(--color-accent)', color: 'var(--color-accent)' }} onClick={onAdmin} data-doc-id="header-admin">
                Admin
              </button>
            )}
          </div>
        )}
      </div>
      <div style={styles.right}>
        <ProfileImage uid={user?.uid} profileImage={user?.profileImage} size={28} />
        <span style={styles.user}>{user?.email}</span>
        {onProfile && (
          <button style={styles.button} onClick={onProfile} data-doc-id="header-profile">
            Profile
          </button>
        )}
        <button style={styles.button} onClick={onLogout} data-doc-id="header-logout">
          Logout
        </button>
      </div>
    </header>
  );
}
